import { render, staticRenderFns } from "./ModalShiftWorkAdmin.vue?vue&type=template&id=2f4b50da&scoped=true"
import script from "./ModalShiftWorkAdmin.vue?vue&type=script&lang=js"
export * from "./ModalShiftWorkAdmin.vue?vue&type=script&lang=js"
import style0 from "./ModalShiftWorkAdmin.vue?vue&type=style&index=0&id=2f4b50da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4b50da",
  null
  
)

export default component.exports